
define('presentation/welcome/common/onboardingPageIndicatorWidget',[
    'i18next',
    'presentation/welcome/common/onboardingNavigationManager',
    'settings/navigationConfiguration'
], () => {
    const _navigationConfiguration = require('settings/navigationConfiguration');

    const OnboardingNavigationManagerConstructor = require('presentation/welcome/common/onboardingNavigationManager');
    const _onboardingNavigationManager = new OnboardingNavigationManagerConstructor();
    _onboardingNavigationManager.init();

    const ROUTE_ID__ONBOARDING_WELCOME = _navigationConfiguration.routesById.liveReceptionistOnboardingWelcome.routeId;
    const ROUTE_ID__ONBOARDING_SCHEDULING = _navigationConfiguration.routesById.liveReceptionistOnboardingScheduling.routeId;
    const ROUTE_ID__ONBOARDING_PROCESSING = _navigationConfiguration.routesById.liveReceptionistOnboardingProcessing.routeId;

    const HIDDEN_ROUTE_IDS = [
        ROUTE_ID__ONBOARDING_WELCOME,
        ROUTE_ID__ONBOARDING_SCHEDULING,
        ROUTE_ID__ONBOARDING_PROCESSING
    ];

    const FINISH_LATER_HIDDEN_ROUTE_IDS = [
        ROUTE_ID__ONBOARDING_PROCESSING
    ];

    const _isFinishLaterVisible = () => {
        return FINISH_LATER_HIDDEN_ROUTE_IDS.indexOf(_onboardingNavigationManager.getRouteId()) === -1;
    };

    const _getStepState = () => {
        const routeId = _onboardingNavigationManager.getRouteId();

        if (HIDDEN_ROUTE_IDS.indexOf(routeId) !== -1) {
            return { isVisible: false, step: 0, totalSteps: 0, percentage: 0 };
        }

        const flow = _onboardingNavigationManager.getFlow();
        const step = flow.routeIndexes[routeId] + 1;
        const totalSteps = flow.routes.length;

        return {
            isVisible: true,
            step: step,
            totalSteps: totalSteps,
            percentage: (step / totalSteps) * 100
        };
    };

    const _setIndicatorWidgetState = (isPageIndicatorVisible, progressPercentage) => {
        if (_getStepState().isVisible === false) {
            isPageIndicatorVisible(false);
            progressPercentage(0);
            return;
        }

        isPageIndicatorVisible(true);

        const targetPercentage = _getStepState().percentage;

        const animateProgressBar = (start, end, observable) => {
            if (start === end) {
                observable(end);
                return;
            }

            const stepTime = 10;  // handles duration of animation
            const stepAmount = Math.abs(end - start) / 20; // handles smoothness of animation

            let current = start;
            const step = end > start ? stepAmount : -stepAmount;

            const interval = setInterval(() => {
                current += step;
                if ((step > 0 && current >= end) || (step < 0 && current <= end)) {
                    current = end;
                    clearInterval(interval);
                }
                observable(current);
            }, stepTime);
        };

        animateProgressBar(progressPercentage(), targetPercentage, progressPercentage);
    };

    return {
        getStepState: _getStepState,
        setIndicator: _setIndicatorWidgetState,
        isFinishLaterVisible: _isFinishLaterVisible
    };
});

